import { Component, OnInit, AfterViewInit } from '@angular/core';
import {
  EASY_MIGRATION_IMAGE_PATH,
  PARTNER_BG,
  ECO_SYS_BG,
  PARTNER_MAP_IMG,
  MAP_DETAILS,
  SMART_ERP_PARNER_PROG,
  BENEFITS_OF_PATNER,
  PARTNER_PROGRAM,
  PATNER_GET_STAETED_IMAGE
} from '../../assets/assets_constant';

declare const lucide: any;
@Component({
  selector: 'app-partner',
  templateUrl: './partner.component.html',
  styleUrls: ['./partner.component.css']
})
export class PartnerComponent implements OnInit, AfterViewInit {
  imagePath = EASY_MIGRATION_IMAGE_PATH;
  bannerImage: String = PARTNER_BG;
  ecosysBgImage = ECO_SYS_BG;
  partnerMapImg = PARTNER_MAP_IMG;
  mapDetails = MAP_DETAILS;
  smartErpPartnerProg = PARTNER_PROGRAM;
  benefitsOfPatner = BENEFITS_OF_PATNER;
  getstarted = PATNER_GET_STAETED_IMAGE;

  // Partner Benefits Data
  partnerBenefits = [
    {
      icon: 'shield',
      title: 'Made-in-India, Open-Source Platforms',
      description: 'Scalable, secure, and cost-efficient solutions built to meet enterprise demands.'
    },
    {
      icon: 'award',
      title: 'Trusted Across Sectors',
      description: 'Proven track record across defense, maritime, manufacturing, and global enterprises.'
    },
    {
      icon: 'layers',
      title: 'Comprehensive Product Portfolio',
      description: 'ERP (EPPS Smart ERP), SAMUDRA (maritime automation), DRONA (digital data security), GCC-Flex (global delivery).'
    },
    {
      icon: 'plug',
      title: 'Seamless Integrations',
      description: 'Interoperable with SAP, Oracle, Salesforce, and other enterprise systems.'
    },
    {
      icon: 'trending-up',
      title: 'Shared Growth',
      description: 'Build long-term client relationships and unlock new revenue opportunities.'
    }
  ];

  // Alignment Features Data
  alignmentFeatures = [
    {
      icon: 'layers',
      title: 'Extend Your Portfolio',
      description: 'Offer AI-powered ERP, maritime automation, DRM, and GCC enablement under your brand.'
    },
    {
      icon: 'users',
      title: 'Offload Complex Projects',
      description: 'Leverage EPPS\'s engineering expertise to scale project delivery.'
    },
    {
      icon: 'target',
      title: 'Enhance Client Success',
      description: 'Deliver predictive analytics, process automation, and integrated support.'
    },
    {
      icon: 'globe',
      title: 'Expand Reach Seamlessly',
      description: 'Enable cross-border delivery with GCC-Flex and digital transformation solutions.'
    },
    {
      icon: 'zap',
      title: 'Accelerate Time-to-Impact',
      description: 'Use our pre-built frameworks to speed up deployments and client outcomes.'
    }
  ];

  // Partner Categories Data
  partnerCategories = [
    {
      icon: 'users',
      title: 'Sales Partner',
      description: 'Focus on sales and business development with EPPS solutions',
      features: [
        'Sales training and certification',
        'Marketing support and collateral',
        'Lead generation assistance',
        'Revenue sharing opportunities',
        'Dedicated sales support'
      ]
    },
    {
      icon: 'settings',
      title: 'Technology Partner',
      description: 'Technical integration and implementation expertise',
      features: [
        'Technical training and certification',
        'Implementation support',
        'Custom development opportunities',
        'API access and documentation',
        'Technical support and resources'
      ]
    },
    {
      icon: 'handshake',
      title: 'Strategic Partner',
      description: 'Comprehensive partnership with full ecosystem access',
      features: [
        'Complete product portfolio access',
        'Joint go-to-market strategies',
        'Co-development opportunities',
        'Priority support and resources',
        'Executive relationship management'
      ]
    }
  ];

  // Demo popup state
  showDemoPopup = false;

  constructor() { }

  ngOnInit() { }

  ngAfterViewInit(): void {
    // Initialize Lucide icons for this page content
    if (typeof lucide !== 'undefined') {
      lucide.createIcons();
    }
    // Re-run shortly after to cover async DOM
    setTimeout(() => {
      if (typeof lucide !== 'undefined') {
        lucide.createIcons();
      }
    }, 100);
  }

  // Demo popup methods
  openDemoPopup(): void {
    this.showDemoPopup = true;
    // Re-initialize icons after modal opens
    setTimeout(() => {
      if (typeof lucide !== 'undefined') {
        lucide.createIcons();
      }
    }, 100);
  }

  closeDemoPopup(): void {
    this.showDemoPopup = false;
  }

  onDemoFormSubmitted(event: any): void {
    // Handle form submission if needed
    console.log('Demo form submitted:', event);
    this.closeDemoPopup();
  }
}
